// Accordion labels switched to sentence case (acronyms kept).
import React from 'react';

import { NativeResources } from '@ariksa/inventory-core';
import { EntityType } from '@ariksa/inventory-core/api';
import { useSelector } from 'react-redux';

import { IconTypes } from 'components/Icons';
import { MetaAccordionItem } from 'containers/ActiveCloudResource/Components/ResourceMetadataDrawer/Components/MetaAccordionItem';
import { ResourceAccessPattern } from 'containers/ActiveCloudResource/Components/ResourceMetadataDrawer/ResourceMetadata/Access/ResourceAccessPattern';
import { selectActiveResource } from 'containers/ActiveCloudResource/selectors';

// conditionally render ResourceAccessPatternAccordion based on resourceType
export const ResourceAccessPatternAccordion = () => {
  const { resourceType } = useSelector(selectActiveResource);
  const { accessed } = useSelector(selectActiveResource);
  // Only IAM users/roles have an access pattern; mapToEntityType returns
  // undefined for the rest (it used to log an error for every one of them).
  const entityType = mapToEntityType(resourceType as NativeResources);
  if (!entityType) return null;

  return (
    <MetaAccordionItem
      iconType={IconTypes.DataScan}
      label={'Actions performed by this identity during last 30 days'}
      panel={<ResourceAccessPattern resourceType={entityType!} />}
      iconBGColor="primary"
      height={'450px'}
      isLoading={accessed.isLoading}
    />
  );
};

const mapToEntityType = (resourceType: NativeResources) => {
  switch (resourceType) {
    case NativeResources.IamUser:
      return EntityType.IamUser;
    case NativeResources.IamRole:
      return EntityType.Role;
    default:
      return undefined;
  }
};
